import { price as priceUtil } from '@eti/utils';
import { css } from '@eti/styles';
import { ScreenReaderPrice } from '@eti/components';
import type { TransformedTDCartPaymentMethodPriceType } from '../../../common/types/transformations/models';

const listStyle = css`
  display: flex;
  justify-content: space-between;
`;

interface CartPaymentFeesProps {
  paymentMethods: TransformedTDCartPaymentMethodPriceType[];
}

const { formatPrice } = priceUtil;

const CartPaymentFees = ({ paymentMethods }: CartPaymentFeesProps) => {
  return (
    <ul data-testid="cart-paymentFees-content">
      {paymentMethods.map(({ name, price, id }) => (
        <li className={listStyle} key={id + name}>
          <span>{name}</span>
          <span aria-hidden>{formatPrice(price)}</span>
          <ScreenReaderPrice price={formatPrice(price)} />
        </li>
      ))}
    </ul>
  );
};

export default CartPaymentFees;
